module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('header', {
    staticClass: "view__header"
  }, [_c('h2', {
    staticClass: "view__title"
  }, [_vm._v(_vm._s(_vm.L.localize('Campaigns_Breadcrumb_Index')))])]), _vm._v(" "), _c('list', {
    staticClass: "view__content",
    attrs: {
      "data": _vm.entries(),
      "fields": _vm.headers(),
      "hideCreate": false
    },
    on: {
      "action": _vm.action
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5fbd39a4!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/campaigns/Campaigns.vue
// module id = 738
// module chunks = 1